// extracted by mini-css-extract-plugin
module.exports = {"variant":"VariantComponent_variant__2glRs"};